import styles from "./home.module.css";
import { useHomeQuery } from "../../../queries/useHomeQuery";
import { useState, useEffect } from "react";
import {
  Collections,
  FeaturedBanner,
  PromotionalBanner,
  Testimonial,
  Blogs,
  ServiceFeatures,
  HandWearCollection,
} from "../../../components/index.js";
import { Products, ThumbnailSlider } from "../../../components/web-app/index";
import { useGetWishLists } from "../../../queries/useWishListQuery.js";
import BrandSlider from "../../../src/components/Brands/brands.jsx";
import ProductPopup from "../../../components/web-app/ProductPopup/ProductPopup.jsx";
// import HomeImagePopup from "../../../components/Imagepopup/Imagepopup.jsx";
const Home = () => {
  const { data } = useHomeQuery();
  //  const [showPopup, setShowPopup] = useState(false);
  const {
    banners = [],
    categories = [],
    top_offers = [],
    new_arrivals = [],
    trending_products = [],
    sections = [],
  } = data || {};
  const sortedSections = [...sections].sort(
    (a, b) => a.sort_order - b.sort_order,
  );
  const firstSection = sortedSections[0];
  const remainingSections = sortedSections.slice(1);
  console.log(new_arrivals, "NEW ARRIVALS");
  const { data: wishItems = [], isPending } = useGetWishLists();
  // ✅ Filter products where quantity > 0
  const filteredNewArrivals = new_arrivals.filter((product) => product.qty > 0);
  const filteredTrendingProducts = trending_products.filter(
    (product) => product.qty > 0,
  );
  const filteredTopOffers = top_offers.filter((product) => product.qty > 0);
  console.log(filteredNewArrivals, "filterednew arii");
  //   useEffect(() => {
  //   setShowPopup(true);
  // }, []);
  return (
    <>
      {/* <HomeImagePopup   
  isOpen={showPopup}
  onClose={() => setShowPopup(false)}
/> */}
      {/* Home Thumbnail Slider */}
      <ThumbnailSlider bannersData={banners} />
      {/* Our Collections */}
      {/* <Collections categories={categories} />  */}
      {/* FeaturedBanner */}
      <FeaturedBanner />
      {/* HandWearCollection */}
      {/* <HandWearCollection categories={categories} />  */}
      {/* <div className={styles.handwear__wrapper}>
        <Products
          title="Earrings"
          category="new"
          wishItems={wishItems}
          isWishListPending={isPending}
          products={filteredNewArrivals}
          variant="slider"
        />
        <Products
          title="Finger Ring"
          category="wedding"
          products={filteredTrendingProducts}
          wishItems={wishItems}
          isWishListPending={isPending}
          variant="slider"
        />
      </div> */}
      {/* first section */}
      {firstSection && (
        <div className={styles.homeproduct__wrapper}>
          <Products
            key={firstSection.id}
            title={firstSection.name}
            products={firstSection.products.filter((p) => p.qty > 0)}
            wishItems={wishItems}
            isWishListPending={isPending}
            variant="slider"
          />
        </div>
      )}
      {/* Promotional Banner */}
      <PromotionalBanner />
      {/* Products */}
      <div className={styles.homeproduct__wrapper}>
        {remainingSections.map((section) => {
          const filteredProducts = section.products.filter(
            (product) => product.qty > 0,
          );

          return (
            <Products
              key={section.id}
              title={section.name}
              products={filteredProducts}
              wishItems={wishItems}
              isWishListPending={isPending}
              variant="slider"
            />
          );
        })}
      </div>
      {/* <BrandSlider/>  */}
      {/* Testimonial */}
      <Testimonial />
      {/* Blogs */}
      {/* <Blogs />  */}
      {/* Service section */}
      {/* <ServiceFeatures />  */}
      <ProductPopup
        products={
          firstSection?.products?.filter(
            (p) => Number(p.qty || p.quantity) > 0,
          ) || []
        }
      />
    </>
  );
};
export default Home;
